import { render, staticRenderFns } from "./DocumentChecklistEditor.vue?vue&type=template&id=40a5d47a"
import script from "./DocumentChecklistEditor.vue?vue&type=script&lang=js"
export * from "./DocumentChecklistEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports